import { render, staticRenderFns } from "./WorkFlos.vue?vue&type=template&id=f1a3f1aa&scoped=true&"
import script from "./WorkFlos.vue?vue&type=script&lang=js&"
export * from "./WorkFlos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a3f1aa",
  null
  
)

export default component.exports